import { render, staticRenderFns } from "./addSuccess.vue?vue&type=template&id=6f9bb506&scoped=true&"
import script from "./addSuccess.vue?vue&type=script&lang=js&"
export * from "./addSuccess.vue?vue&type=script&lang=js&"
import style0 from "./addSuccess.vue?vue&type=style&index=0&id=6f9bb506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9bb506",
  null
  
)

export default component.exports